

































































































import Vue, { PropType } from 'vue';

export interface CheckListData {
  id: string;
  title: string;
  price: number;
  isPriceUndecided: boolean;
  imageUrl: string;
  checked: boolean;
}

export default Vue.extend({
  name: 'GCheckListTable',
  props: {
    checklist: Array as PropType<CheckListData[]>,
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.checklist);
    });
  },
  methods: {
    onCheck(boothId: string, itemId?: string) {
      console.log('checklist', this.checklist[0]);
      this.$emit('check', boothId, itemId);
    },
    onClickItem(itemId: string) {
      window.open(`/ssr/it/${itemId}`);
    },
    openWebsite(url: string) {
      window.open(url);
    },
  },
});
